import React, { Component, TextArea } from 'react';
import PropTypes from 'prop-types';

class FieldTextAreaStateless extends React.Component {
  constructor(props) {
    super(props);
  }

  getResizeValue(enableResize) {
    return enableResize ? "both" : "none";
  }

  render() {
    const {
      autoFocus,
      disabled,
      id,
      isReadOnly,
      maxLength,
      rows,
      name,
      placeholder,
      enableResize,
      required,
      value,
      className,
      onChange,
    } = this.props;

    const style = {
      resize: this.getResizeValue(enableResize)
    };

    return(
      <textarea
        disabled={disabled}
        readOnly={isReadOnly}
        name={name}
        placeholder={placeholder}
        value={value}
        required={required}
        rows={rows}
        id={id}
        autoFocus={autoFocus}
        maxLength={maxLength}
        className={className}
        style={style}
        onChange={onChange}
      />
    );
  }

}

// Specifies the default values for props:
FieldTextAreaStateless.defaultProps = {
  disabled: false,
  readOnly: false,
  required: false,
  rows: 1,
  enableResize: false,
};

export default FieldTextAreaStateless;
